<template>
  <textarea style="display:none !important;" id="editor1" name="editor1">

  </textarea>
</template>

<script>
export default {
    name:"CkEditor",
    props:["content"],
    emits: ['sendContent'],
    mounted() {
        // initialize ckeditor 
        let ckEditor
        ckEditor = window.CKEDITOR.replace("editor1")
        ckEditor.setData(this.content)
        ckEditor.on('change',()=>{
            this.$emit('sendContent',ckEditor.getData())
        })
    },
    // setup(props,{emit}){
    //     const content = ref(props.content)
    //     let ckEditor;
    //     onMounted(()=>{
    //         // initialize ckeditor 
    //         ckEditor = window.CKEDITOR.replace("editor1")
    //         ckEditor.setData(content.value)

    //         ckEditor.on('change',()=>{
    //             emit('sendContent',ckEditor.getData())
    //         })
    //     })
    // }

}
</script>

<style>

</style>